// extracted by mini-css-extract-plugin
export default {"root":"styles_root__G06vY","isProcessing":"styles_isProcessing__bhEtA","buttonSpinner":"styles_buttonSpinner__4FeID"};